import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect } from "react";
import { ResolveThunks, connect } from "react-redux";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import adiRMAStatusDetails from "@NA/Handlers/ADIRMAStatusDetailsHandler";
import Typography from "@insite/mobius/Typography";
import translate from "@insite/client-framework/Translate";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { ReturnDetailViewOrderLineModel } from "@NA/Services/ADIRMAStatusDetailsService";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";

const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    let getCurrentUrl;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ rmaReturnID: string; print: string }>(location.search);
        getCurrentUrl = parsedQuery.rmaReturnID;
    }
    return {
        getCurrentUrl,
        session: state.context.session,
        isLoading: state.ADIGlobalData.ReturnHistoryDetails.isLoading,
        returnStatusDataView: state.ADIGlobalData.ReturnHistoryDetails?.data,
        getQuotesParameter: state.ADIGlobalData.quotesListStore.parameter,
    };
};

const mapDispatchToProps = {
    adiRMAStatusDetails,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface RMAStatusDetailsContainerStyles {
    statusDetailsWrap?: InjectableCss;
    statusDetailsHead?: InjectableCss;
    statusDetailsHeadInfo?: InjectableCss;
    statusDetailsHeadDesc?: InjectableCss;
    statusDetailsBody?: InjectableCss;
    statusDetailsBodyImg?: InjectableCss;
    statusDetailsBodyInfo?: InjectableCss;
    statusDetailsBodyDesc?: InjectableCss;
    statusDetailSubInfo?: InjectableCss;
    statusDetailSubInfoRightSection?: InjectableCss;
    statusDetailsText?: InjectableCss;
    statusDetailsItems?: InjectableCss;
    statusDetailsItem?: InjectableCss;
}

export const RMAStatusDetailsContainerStyles: RMAStatusDetailsContainerStyles = {
    statusDetailSubInfo: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                    `,
                    css`
                        flex-wrap: wrap;
                    `,
                    css`
                        flex-wrap: wrap;
                    `,
                    css``,
                    css`
                        flex-wrap: wrap;
                    `,
                ])}
        `,
    },
    statusDetailSubInfoRightSection: {
        css: css`
            display: flex;
            flex-wrap: nowrap;
        `,
    },
    statusDetailsHead: {
        css: css`
            display: flex;
            margin-bottom: 15px;
            h4 {
                color: #000;
                font-weight: bold;
                padding-right: 1em;
                padding-left: 0;
                white-space: nowrap;
                font-size: 14px;
            }
            p {
                color: #535353;
                font-weight: normal;
                padding-right: 1em;
                padding-left: 0;
                white-space: nowrap;
                font-size: 14px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                    `,
                    css`
                        flex-wrap: wrap;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    statusDetailsHeadInfo: {
        css: css`
            width: 13.66667%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 25%;
                    `,
                    css`
                        width: 30%;
                    `,
                    css`
                        width: 13.66667%;
                    `,
                ])}
        `,
    },
    statusDetailsHeadDesc: {
        css: css`
            width: 86.33333%;
            h4 {
                color: #000;
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 14px;
            }
            p {
                display: table-cell;
                width: 125px;
                vertical-align: top;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin-top: 15px;
                        h4 {
                            margin-bottom: 0px;
                        }
                    `,
                    css`
                        width: 100%;
                        margin-top: 15px;
                        h4 {
                            margin-bottom: 0px;
                        }
                    `,
                    css`
                        width: 75%;
                    `,
                    css`
                        width: 70%;
                    `,
                    css`
                        width: 86.33333%;
                    `,
                ])}
        `,
    },
    statusDetailsItem: {
        css: css`
            border-top: 1px solid #e0e0e0;
            padding: 16px 0;
            display: flex;
            :last-child {
                border-bottom: 1px solid #e0e0e0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                    `,
                    css`
                        flex-wrap: wrap;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    statusDetailsItems: {
        css: css``,
    },
    statusDetailsBodyImg: {
        css: css`
            width: 15%;
            text-align: center;
            img {
                width: 113px;
                height: 113px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        text-align: left;
                        img {
                            width: 100px;
                            height: auto;
                        }
                    `,
                    css`
                        width: 15%;
                        img {
                            width: 100px;
                            height: auto;
                        }
                    `,
                    css`
                        width: 15%;
                    `,
                    css`
                        width: 15%;
                    `,
                    css`
                        width: 15%;
                    `,
                ])}
        `,
    },
    statusDetailsBodyInfo: {
        css: css`
            width: 37%;
            padding-left: 40px;
            p {
                color: #333;
                line-height: 21px;
                font-size: 11px;
                font-weight: normal;
                padding-right: 0em;
            }
            h4 {
                font-weight: bold;
                word-break: break-all;
                text-decoration: none !important;
                color: #000;
                cursor: default;
                text-transform: uppercase;
                text-align: left;
                display: inline-block;
                line-height: 1.5 !important;
                word-wrap: break-word;
                font-size: 12px !important;
                margin-bottom: 10px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        padding-left: 0px;
                        padding: 0 15px 0px 0px !important;
                    `,
                    css`
                        width: 80%;
                        padding-left: 0px;
                        padding: 0 15px 15px 15px !important;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    statusDetailsBodyDesc: {
        css: css`
            width: 37%;
            padding-left: 65px;
            h5 {
                float: none;
                min-width: 110px;
                width: 110px;
                font-size: 12px;
                line-height: 18px;
                white-space: inherit;
                vertical-align: top;
                display: table-cell;
            }
            p {
                float: none;
                font-size: 12px;
                line-height: 18px;
                white-space: inherit;
                vertical-align: top;
                display: table-cell;
            }
            h4 {
                font-weight: bold;
                word-break: break-all;
                text-decoration: none !important;
                color: #000;
                cursor: default;
                /* text-transform: uppercase; */
                text-align: left;
                display: inline-block;
                line-height: 1.5 !important;
                word-wrap: break-word;
                font-size: 12px !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        padding-left: 0px;
                        padding: 0 15px 15px 0px !important;
                    `,
                    css`
                        width: 100%;
                        padding-left: 0px;
                        padding: 0 15px 15px 0px !important;
                    `,
                    css`
                        width: 48%;
                    `,
                    css`
                        width: 48%;
                    `,
                    null,
                ])}
        `,
    },
};

const styles = RMAStatusDetailsContainerStyles;

const ADIRMAStatusDetailsContainer: React.FC<Props> = ({
    returnStatusDataView,
    adiRMAStatusDetails,
    isLoading,
    getCurrentUrl,
}) => {
  
    useEffect(() => {
        if(getCurrentUrl){
        adiRMAStatusDetails({
            rmaReturnId: getCurrentUrl,
        });
    }
    }, []);

    if (!getCurrentUrl) {
        return null;
    }
    
    return (
        <>
            <LoadingOverlay loading={isLoading} spinnerProps={{ color: "primary" }}>
                {returnStatusDataView && (
                    <StyledWrapper {...styles.statusDetailsWrap}>
                        <StyledWrapper {...styles.statusDetailsHead}>
                            <StyledWrapper {...styles.statusDetailsHeadInfo}>
                                <StyledWrapper {...styles.statusDetailSubInfo}>
                                    <Typography as="h4">{translate("PO Number")}</Typography>
                                    <Typography as="p">{returnStatusDataView.customerPO}</Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.statusDetailSubInfo}>
                                    <Typography as="h4">{translate("Web Return ID")}</Typography>
                                    <Typography as="p">{returnStatusDataView.rmaReturnID}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                            <StyledWrapper {...styles.statusDetailsHeadDesc}>
                                <Typography as="h4">{translate("Contact for Return")}</Typography>
                                <StyledWrapper {...styles.statusDetailSubInfo}>
                                    <Typography as="p">{translate("Contact Name:")}</Typography>
                                    <Typography as="p">{returnStatusDataView.contactName}</Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.statusDetailSubInfo}>
                                    <Typography as="p">{translate("Phone Number:")}</Typography>
                                    <Typography as="p">{returnStatusDataView.phoneNumber}</Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.statusDetailSubInfo}>
                                    <Typography as="p">{translate("Email:")}</Typography>
                                    <Typography as="p">{returnStatusDataView.email}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>

                        <StyledWrapper {...styles.statusDetailsBody}>
                            <StyledWrapper {...styles.statusDetailsItems}>
                                {returnStatusDataView?.ordersRetrunHistoryLineModel.map(
                                    (item: ReturnDetailViewOrderLineModel, index: number) => {
                                        return (
                                            <StyledWrapper {...styles.statusDetailsItem}>
                                                <StyledWrapper {...styles.statusDetailsBodyImg}>
                                                    <img src={item.productImageUri} alt="" />
                                                </StyledWrapper>
                                                <StyledWrapper {...styles.statusDetailsBodyInfo}>
                                                    <Typography as="h4">{item.productName}</Typography>
                                                    <StyledWrapper {...styles.statusDetailSubInfo}>
                                                        <Typography as="p">{item.productCategory}</Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.statusDetailSubInfo}>
                                                        <Typography as="p">{translate("ADI #")}</Typography>
                                                        <Typography as="p">{item.adiPartNumber}</Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.statusDetailSubInfo}>
                                                        <Typography as="p">{translate("Model #")}</Typography>
                                                        <Typography as="p">{item.productModel}</Typography>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                                <StyledWrapper {...styles.statusDetailsBodyDesc}>
                                                    <StyledWrapper {...styles.statusDetailSubInfoRightSection}>
                                                        <Typography as="h5">{translate("Return Status:")}</Typography>
                                                        <Typography as="h4">{item.returnStatus}</Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.statusDetailSubInfoRightSection}>
                                                        <Typography as="h5">{translate("Order:")}</Typography>
                                                        <Typography as="p">{item.orderNo}</Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.statusDetailSubInfoRightSection}>
                                                        <Typography as="h5">
                                                            {translate("Reason for Return:")}
                                                        </Typography>
                                                        <Typography as="p">{item.returnReason}</Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.statusDetailSubInfoRightSection}>
                                                        <Typography as="h5">{translate("Return Options:")}</Typography>
                                                        <Typography as="p">{item.returnOption}</Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.statusDetailSubInfoRightSection}>
                                                        <Typography as="h5">{translate("Description:")}</Typography>
                                                        <Typography as="p">{item?.returnOptionNotes}</Typography>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        );
                                    },
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                )}
            </LoadingOverlay>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ADIRMAStatusDetailsContainer)),
    definition: {
        group: "Basic",
        displayName: "ADI RMA Status Details",
    },
};

export default widgetModule;
